<template>
    <div class="secure-sign__container">
        <v-container>
            <s-s-form-header
                title="Denzapine Monitoring Service Pharmacy Registration Form"
                document-number="PV01F03"
                version="6.0"
                effective-date="31 Jan 2024"
                review-date="31 Jan 2026"
                supersedes="5.0"
            ></s-s-form-header>
            <v-col class="text-center">
                <h1 class="mb-5">Denzapine Monitoring Service Pharmacy Registration Form</h1>
                <h4 class="mb-8">
                    Please complete all fields before submission of this form. Missing information may lead to delays in
                    processing the application.
                </h4>
            </v-col>
            <v-col cols="12">
                <v-form ref="form" v-model="isFormValid" :disabled="isDisabled">
                    <v-row>
                        <v-col cols="12" class="pt-10 pb-0">
                            <h5 class="patient-form-title">Hospital / Pharmacy Details</h5>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-0">
                            <b-textarea
                                to-mutate="secure_sign_forms::pharmacyRegistrationForm.hospitalName"
                                label="Hospital Name:"
                                :rules="validationRules.hospitalName"
                                mandatory
                                :rows="1"
                                :auto-grow="true"
                                :printable="true"
                            ></b-textarea>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-0">
                            <b-textarea
                                to-mutate="secure_sign_forms::pharmacyRegistrationForm.pharmacySiteName"
                                label="Pharmacy Site Name:"
                                :rules="validationRules.pharmacySiteName"
                                mandatory
                                :rows="1"
                                :auto-grow="true"
                                :printable="true"
                            ></b-textarea>
                        </v-col>
                        <v-col cols="12" class="py-0">
                            <b-textarea
                                to-mutate="secure_sign_forms::pharmacyRegistrationForm.pharmacyAddress"
                                label="Address:"
                                :rules="validationRules.pharmacyAddress"
                                mandatory
                                :rows="1"
                                :auto-grow="true"
                                :printable="true"
                            ></b-textarea>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-0">
                            <b-textarea
                                to-mutate="secure_sign_forms::pharmacyRegistrationForm.pharmacyPhoneNumber"
                                label="Phone Number:"
                                :rules="validationRules.pharmacyPhoneNumber"
                                mandatory
                                :rows="1"
                                :auto-grow="true"
                                :printable="true"
                            ></b-textarea>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-0">
                            <b-textarea
                                to-mutate="secure_sign_forms::pharmacyRegistrationForm.pharmacyEmail"
                                label="Pharmacy Email:"
                                :rules="validationRules.pharmacyEmail"
                                mandatory
                                :rows="1"
                                :auto-grow="true"
                                :printable="true"
                            ></b-textarea>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="pt-10 pb-0">
                            <h5 class="patient-form-title">Responsible Pharmacist / Chief Pharmacist Details</h5>
                        </v-col>
                        <v-col cols="12" class="py-0">
                            <b-textarea
                                to-mutate="secure_sign_forms::pharmacyRegistrationForm.responsiblePharmacist"
                                label="Responsible Pharmacist / Chief Pharmacist Name:"
                                :rules="validationRules.responsiblePharmacist"
                                mandatory
                                :rows="1"
                                :auto-grow="true"
                                :printable="true"
                            ></b-textarea>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-0">
                            <b-textarea
                                to-mutate="secure_sign_forms::pharmacyRegistrationForm.pharmacistPhoneNumber"
                                label="Phone Number:"
                                :rules="validationRules.pharmacistPhoneNumber"
                                mandatory
                                :rows="1"
                                :auto-grow="true"
                                :printable="true"
                            ></b-textarea>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-0">
                            <b-textarea
                                to-mutate="secure_sign_forms::pharmacyRegistrationForm.pharmacistEmail"
                                label="Email Address:"
                                :rules="validationRules.pharmacistEmail"
                                mandatory
                                :rows="1"
                                :auto-grow="true"
                                :printable="true"
                            ></b-textarea>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="pt-10 pb-0">
                            <h5 class="patient-form-title">Pharmacy Technician Details</h5>
                        </v-col>
                        <v-col cols="12" class="py-0">
                            <b-textarea
                                to-mutate="secure_sign_forms::pharmacyRegistrationForm.technicianName"
                                label="Pharmacy Technician Name:"
                                :rules="validationRules.technicianName"
                                mandatory
                                :rows="1"
                                :auto-grow="true"
                                :printable="true"
                            ></b-textarea>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-0">
                            <b-textarea
                                to-mutate="secure_sign_forms::pharmacyRegistrationForm.technicianPhoneNumber"
                                label="Phone Number:"
                                :rules="validationRules.technicianPhoneNumber"
                                mandatory
                                :rows="1"
                                :auto-grow="true"
                                :printable="true"
                            ></b-textarea>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-0">
                            <b-textarea
                                to-mutate="secure_sign_forms::pharmacyRegistrationForm.technicianEmail"
                                label="Email Address:"
                                :rules="validationRules.technicianEmail"
                                mandatory
                                :rows="1"
                                :auto-grow="true"
                                :printable="true"
                            ></b-textarea>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="pt-10 pb-0">
                            <h5 class="patient-form-title">Out of hours contact</h5>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-0">
                            <b-textarea
                                to-mutate="secure_sign_forms::pharmacyRegistrationForm.outOfHoursContactName"
                                label="Out of hours Contact Name:"
                                :rules="validationRules.outOfHoursContactName"
                                mandatory
                                :rows="1"
                                :auto-grow="true"
                                :printable="true"
                            ></b-textarea>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-0">
                            <b-textarea
                                to-mutate="secure_sign_forms::pharmacyRegistrationForm.otherContacts"
                                label="Other Contacts:"
                                :rules="validationRules.otherContacts"
                                mandatory
                                :rows="1"
                                :auto-grow="true"
                                :printable="true"
                            ></b-textarea>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="12">
                            <h5 class="patient-form-title mt-5">Signature</h5>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <b-date-picker-store
                                hide-details
                                to-mutate="secure_sign_forms::pharmacyRegistrationForm.date"
                                label="Date"
                                :rules="validationRules.date"
                                mandatory
                            ></b-date-picker-store>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="8">
                            <secure-sign-form-signature-component
                                ref="signaturePad"
                                :form-type="form"
                                :is-disabled="isDisabled"
                            ></secure-sign-form-signature-component>
                        </v-col>
                        <v-col
                            v-if="!isDisabled"
                            cols="12"
                            sm="4"
                            class="d-flex flex-column justify-content-end align-items-center"
                        >
                            <secure-sign-form-recaptcha
                                ref="recaptcha"
                                :valid-recaptcha="validRecaptcha"
                                :is-disabled="isDisabled"
                                @expired="expired"
                                @verify="onRecaptchaVerify"
                            ></secure-sign-form-recaptcha>
                            <v-btn
                                :loading="loading"
                                class="mt-2"
                                max-width="304px"
                                width="100%"
                                size="x-large"
                                color="primary"
                                :disabled="isDisabled"
                                @click="submit"
                                >Submit
                            </v-btn>
                        </v-col>
                        <v-col cols="12" class="text-center font-weight-bold">
                            <p>
                                By signing this form, the pharmacy are agreeing to abide by the obligations set out in
                                the Summary of Product Characteristics (SmPC), namely to only dispense clozapine against
                                a valid blood result. Please contact DMS Team to obtain a copy of the current SmPC if
                                required or refer to the Electronic Medicines Compendium (EMC) website.
                            </p>
                        </v-col>
                    </v-row>
                    <s-s-form-footer ref="footer">
                        <p>
                            Should you have any queries, please do not hesitate to contact the Denzapine Monitoring
                            Service Team on 0333 200 4141
                        </p>
                        <p>Job Code: UK-Denz-2300030, Version 2.0, Date of prep: Apr 2026</p>
                    </s-s-form-footer>
                </v-form>
            </v-col>
        </v-container>
    </div>
</template>

<script>
import SSFormHeader from './partials/SSFormHeader.vue';
import SSFormFooter from './partials/SSFormFooter.vue';

let formControl = require('./mixins/FormControl.js').default;
export default {
    components: { SSFormFooter, SSFormHeader },
    mixins: [formControl],
    data() {
        return {
            validationRules: {
                hospitalName: [(v) => !!v || t('users::validation.field.required')],
                pharmacySiteName: [(v) => !!v || t('users::validation.field.required')],
                pharmacyAddress: [(v) => !!v || t('users::validation.field.required')],
                pharmacyPhoneNumber: [(v) => !!v || t('users::validation.field.required')],
                pharmacyEmail: [(v) => !!v || t('users::validation.field.required'), this.$root.rules.email],
                responsiblePharmacist: [(v) => !!v || t('users::validation.field.required')],
                pharmacistPhoneNumber: [(v) => !!v || t('users::validation.field.required')],
                pharmacistEmail: [(v) => !!v || t('users::validation.field.required'), this.$root.rules.email],
                technicianName: [(v) => !!v || t('users::validation.field.required')],
                technicianPhoneNumber: [(v) => !!v || t('users::validation.field.required')],
                technicianEmail: [(v) => !!v || t('users::validation.field.required'), this.$root.rules.email],
                outOfHoursContactName: [(v) => !!v || t('users::validation.field.required')],
                otherContacts: [(v) => !!v || t('users::validation.field.required')],
                signature: [(v) => !!v || t('users::validation.field.required')],
                date: [(v) => !!v || t('users::validation.field.required')],
            },
            isFormValid: false,
            formType: 'pharmacy-registration-form',
            form: 'pharmacyRegistrationForm',
        };
    },
    created() {
        this.getFormData();
    },
};
</script>

<style scoped></style>
